import React, { useMemo } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Interactive } from "react-interactive";
import { CSSTransition } from "react-transition-group";
import slugify from "slugify";
import LinkWrapper from "~components/utils/link_wrapper/link_wrapper";
import { createAnchorLink } from "~utils/link_utils/createAnchorLink/createAnchorLink";
import * as transitionSlideHorizFadeScale from "../../../../../styles/global_scss_modules/global_css_transition_styles/transition_slide_horiz_fade_scale.module.scss";
import TOCChapterMarker from "../toc_chapter_marker/toc_chapter_marker";
import {
  isActiveStyle,
  linkWrapperStyle,
  textStyle,
} from "./toc_link.module.scss";

const transitionClassnames = { ...transitionSlideHorizFadeScale };

const TRANSITION_TIMEOUT = {
  appear: 200,
  enter: 200,
  exit: 200,
};
function TOCLink({ title, activeItem, isNavExpanded, pagePath }) {
  const isActive = activeItem === title;

  const linkWrapperClassNames = classNames(linkWrapperStyle, {
    [isActiveStyle]: isActive,
  });
  const textClassNames = classNames(textStyle, {
    [isActiveStyle]: isActive,
  });

  const chapterTitleSlug = useMemo(() => {
    return slugify(title, {
      lower: true,
      strict: true,
    });
  }, [title]);

  const link = useMemo(() => {
    return createAnchorLink({
      path: pagePath,
      anchor: chapterTitleSlug,
    });
  }, [chapterTitleSlug, pagePath]);

  return (
    <Interactive as={LinkWrapper} link={link} className={linkWrapperClassNames}>
      <TOCChapterMarker isNavExpanded={isNavExpanded} isActive={isActive} />
      <CSSTransition
        key={title}
        timeout={TRANSITION_TIMEOUT}
        classNames={transitionClassnames}
        appear
        unmountOnExit
        in={isNavExpanded}
      >
        <div className={textClassNames}>{title}</div>
      </CSSTransition>
    </Interactive>
  );
}

TOCLink.propTypes = {
  activeItem: PropTypes.string,
  isNavExpanded: PropTypes.bool,
  pagePath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

TOCLink.defaultProps = {
  activeItem: null,
  isNavExpanded: false,
};

export default TOCLink;
